import { LOCAL_KC_DCM_TOKEN_URL_UNCHANGED_PART } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const localKcDcmTokenApi = createAsyncThunk(
  'localKcDcmToken',
  async (payload: URLSearchParams, { rejectWithValue }) => {
    try {
      const localKCURL = payload.get('kc_url');
      const url = localKCURL +  LOCAL_KC_DCM_TOKEN_URL_UNCHANGED_PART;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: payload,
      };
      const res = await fetch(url, requestOptions);

      // Check if the response is not okay (status is 400 or other errors)
      if (!res.ok) {
        const errorData = await res?.json(); // Extract error message from the res
        return rejectWithValue(errorData?.error_description || 'Error in PACS authorization');
      }

      const data = await res.json();

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
